import { isValid as isValidPublicSuffix } from 'psl';
import { z } from 'zod';
export const MAX_VALUE_LENGTH = 2048;
export const MAX_BLOCKING_REASON_LENGTH = 1000;
const HOST_LABEL_PATTERN = /^[a-z0-9-]+$/i;
export const isValidBlocklistUrlValue = (value)=>{
    var _withoutScheme_split_;
    const withoutScheme = value.trim().replace(/^https?:\/\//i, '');
    const host = (_withoutScheme_split_ = withoutScheme.split(/[/?]/, 1)[0]) != null ? _withoutScheme_split_ : '';
    const labels = host.split('.');
    return labels.length >= 2 && labels.every((label)=>HOST_LABEL_PATTERN.test(label)) && // Shape alone admits invented TLDs (`wawetra.sadgdsg`); the Public Suffix List is the arbiter.
    isValidPublicSuffix(host.toLowerCase());
};
const MIN_BLOCKLIST_ADDRESS_LENGTH = 10;
const MIN_BLOCKLIST_ADDRESS_WORDS = 4;
// Scripts below write addresses without spaces, so the word heuristic can't apply; a
// "full address" in them still runs well past this many characters.
const MIN_BLOCKLIST_ADDRESS_UNSPACED_LENGTH = 12;
// CJK (Han, Hiragana, Katakana, Hangul) plus Thai — the scripts we see in merchant
// addresses that don't delimit words with whitespace.
const UNSPACED_SCRIPT_PATTERN = /[぀-ヿ㐀-䶿一-鿿가-힯豈-﫿฀-๿]/;
// A "full address" (street, city, country) runs to several words, whereas a street
// line alone is 2-3 ("Licoln 20", "123 Main Street"). We approximate completeness by
// word count so no punctuation/format is imposed — commas are optional and a ZIP/street
// number is not required. This is a heuristic: it can't verify a country is present,
// only that the value is richer than a lone street line.
export const isValidBlocklistAddressValue = (value)=>{
    const trimmed = value.trim();
    if (trimmed.length < MIN_BLOCKLIST_ADDRESS_LENGTH) {
        return false;
    }
    const words = trimmed.split(/\s+/).filter(Boolean);
    // Japanese/Chinese/Korean/Thai addresses are written as one run of characters, so
    // splitting on whitespace yields a single "word" and would reject a complete address.
    if (UNSPACED_SCRIPT_PATTERN.test(trimmed)) {
        return trimmed.length >= MIN_BLOCKLIST_ADDRESS_UNSPACED_LENGTH;
    }
    return words.length >= MIN_BLOCKLIST_ADDRESS_WORDS;
};
// The single source of truth for value-validation copy. Duplicating these literals across
// the form, the FE CSV preflight, the BE CSV parser, and the BE service lets the wording
// drift per layer — import from here instead.
export const BLOCKLIST_URL_VALUE_ERROR = 'Enter a valid URL or domain';
export const BLOCKLIST_ADDRESS_VALUE_ERROR = 'Enter a full address including street, city, and country';
export const BlocklistMatchTypeSchema = z.enum([
    'url',
    'company_name',
    'registration_number',
    'address'
]);
export const BlocklistConfidenceSchema = z.enum([
    'medium',
    'high'
]);
export const BlocklistMatchSchema = z.object({
    matchType: BlocklistMatchTypeSchema,
    matchedValue: z.string(),
    // The blocklist record's own stored value ("blocked entity"). Optional: matches persisted
    // before BAL-8116 lack it — the report widget renders an empty cell until backfilled.
    blockedValue: z.string().optional(),
    blockingReason: z.string().nullable(),
    confidence: BlocklistConfidenceSchema
});
export const BlocklistStatusSchema = z.enum([
    'alert',
    'clear'
]);
export const BlocklistResultSchema = z.object({
    status: BlocklistStatusSchema,
    matches: z.array(BlocklistMatchSchema)
});

//# sourceMappingURL=blocklist.schema.js.map